export function isValidEmail(email: string) {
  const regex = /^[a-zA-Z0-9.+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return regex.test(email);
}

export function isValidTag(tag: string) {
  const regex = /^[a-z0-9+_-]+$/;
  return !tag.length || regex.test(tag);
}
